import { render } from "./ViewMediaFileMoreAdvert.vue?vue&type=template&id=bb407fb2&scoped=true"
import script from "./ViewMediaFileMoreAdvert.vue?vue&type=script&lang=js"
export * from "./ViewMediaFileMoreAdvert.vue?vue&type=script&lang=js"

import "./ViewMediaFileMoreAdvert.vue?vue&type=style&index=0&id=bb407fb2&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-bb407fb2"

export default script